<template>
  <div>
    <div class="mb-3">
      <h5>Manage System Administrators</h5>
    </div>

    <div class="text-center" v-if="isInitialisingUI">
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <div v-else>
      <div>
        <b-table striped bordered hover
          stacked="xl"
          v-bind:items="administrators"
          v-bind:fields="tableFields"
          v-bind:busy="tableIsBusy"
          show-empty
          empty-text="No data to show">
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(isEmailConfirmed)="data">
            <span v-if="data.item.isEmailConfirmed">Yes</span>
            <span v-else>No</span>
          </template>
          <template #cell(isDisabled)="data">
            <span v-if="data.item.isDisabled">Yes</span>
            <span v-else>No</span>
          </template>
          <template #cell(actions)="data">
            <b-button class="mr-2" size="sm" variant="info"
              title="Re-send confirmation email"
              v-bind:disabled="!data.item.isEditable || data.item.isEmailConfirmed"
              v-on:click="reconfirmAdministratorClick(data.item)">
              <b-icon-envelope />
            </b-button>
            <b-button class="mr-2" size="sm" variant="info"
              title="Edit"
              v-bind:disabled="!data.item.isEditable"
              v-on:click="editAdministratorClick(data.item)">
              <b-icon-pencil />
            </b-button>
            <b-button class="mr-2" size="sm" variant="danger"
              title="Delete"
              v-bind:disabled="!data.item.isEditable"
              v-on:click="deleteAdministratorClick(data.item)">
              <b-icon-x-circle />
            </b-button>
          </template>
        </b-table>
      </div>
      <div>
        <b-button variant="primary"
        v-bind:disabled="addButtonIsDisabled"
        v-on:click="addAdministratorClick">
          Add System Administrator <b-icon-plus-circle />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SystemAdministrators',
  created() {
    this.initialiseUI();
  },
  data() {
    return {
      tableFields: [
        { key: 'firstName', label: 'First Name', thStyle: { width: '15%' } },
        { key: 'lastName', label: 'Last Name', thStyle: { width: '15%' } },
        { key: 'emailAddress', thStyle: { width: '20%' } },
        { key: 'isEmailConfirmed', label: 'Email Confirmed', thStyle: { width: '15%' } },
        { key: 'isDisabled', label: 'Account Disabled', thStyle: { width: '15%' } },
        { key: 'actions', thStyle: { width: '20%' } },
      ],
      isInitialisingUI: false,
    };
  },
  computed: {
    administrators() {
      return this.$store.state.systemAdministrators.systemAdministrators;
    },
    tableIsBusy() {
      return this.$store.state.systemAdministrators.isLoading;
    },
    addButtonIsDisabled() {
      return this.$store.state.systemAdministrators.isLoading;
    },
  },
  methods: {
    ...mapActions('systemAdministrators', ['getSystemAdministrators', 'deleteSystemAdministrator']),
    ...mapActions('authentication', ['requestUserConfirmation']),
    async initialiseUI() {
      this.isInitialisingUI = true;

      await this.getSystemAdministrators()
        .catch((error) => {
          this.handleHttpError(error);
          this.$store.dispatch('systemAdministrators/clearState');
        });

      this.isInitialisingUI = false;
    },
    addAdministratorClick() {
      this.$router.push({
        name: 'Admin-SystemAdministratorDetails',
        params: {
          administrator: {
            id: 0,
            emailAddress: '',
            firstName: '',
            lastName: '',
          },
          new: true,
        },
      });
    },
    async reconfirmAdministratorClick(administrator) {
      const messageDiv = this.$createElement('div', [
        this.$createElement('p', [
          this.$createElement('strong', 'Information: '),
          "This will re-send the account confirmation email to the System Administrator's email address.",
        ]),
        this.$createElement('p', [
          'Click OK to re-send the confirmation email.',
        ]),
      ]);

      this.$bvModal.msgBoxConfirm(
        messageDiv, {
          title: 'Re-send confirmation',
          okVariant: 'primary',
          centered: true,
          hideHeaderClose: false,
        },
      )
        .then(async (value) => {
          if (value) {
            await this.requestUserConfirmation({ userId: administrator.id })
              .catch((error) => { this.handleHttpError(error); });
          }
        });
    },
    editAdministratorClick(administrator) {
      this.$router.push({
        name: 'Admin-SystemAdministratorDetails',
        params: {
          administrator,
          new: false,
        },
      });
    },
    async deleteAdministratorClick(administrator) {
      const messageDiv = this.$createElement('div', [
        this.$createElement('p', [
          this.$createElement('strong', 'Warning: '),
          'Deleting a System Administrator will remove all their access and all their associated data. This operation is permanent.',
        ]),
        this.$createElement('p', [
          `Are you sure you want to delete "${administrator.firstName} ${administrator.lastName}"?`,
        ]),
      ]);

      this.$bvModal.msgBoxConfirm(
        messageDiv, {
          title: 'Delete System Administrator',
          okVariant: 'danger',
          centered: true,
          hideHeaderClose: false,
        },
      )
        .then(async (value) => {
          if (value) {
            await this.deleteSystemAdministrator(administrator.id)
              .then(async () => { await this.getSystemAdministrators(); })
              .catch((error) => { this.handleHttpError(error); });
          }
        });
    },
  },
};
</script>
